import axios from 'axios';
import { API_URL } from '../config';
import initialState from './initialState';

const reducerName = 'rn_fiz1';
const createActionName = (name) => `app/${reducerName}/${name}`;

export const LOAD_RNFIZ_1 = createActionName('LOAD_RNFIZ_1');
export const ADD_RNFIZ_1 = createActionName('ADD_RNFIZ_1');
export const EDIT_RNFIZ_1 = createActionName('EDIT_RNFIZ_1');
export const DELETE_RNFIZ_1 = createActionName('DELETE_RNFIZ_1');

export const loadRnfiz_1 = (payload) => ({
  payload,
  type: LOAD_RNFIZ_1,
});
export const addRnfiz_1 = (payload) => ({
  payload,
  type: ADD_RNFIZ_1,
});
export const editRnfiz_1 = (payload) => ({
  payload,
  type: EDIT_RNFIZ_1,
});
export const deleteRnfiz_1 = (payload) => ({
  payload,
  type: DELETE_RNFIZ_1,
});

export const createRnfiz1Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/rn-fiz`, data, {
        withCredentials: true,
      });
      dispatch(addRnfiz_1(res.data));
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const removeRnfiz1Request = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/rn-fiz/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteRnfiz_1({ id }));
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createRNFiz2Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/rn-fiz/bottling`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const updateRNFiz2Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/rn-fiz/bottling/${data.id}`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createRNFiz3Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/rn-fiz/fiz3`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const updateRNFiz3Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/rn-fiz/fiz3/${data.id}`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const sendRepairOrderRequestEmail = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(
        `${API_URL}/rn-fiz/send-repair-order-email`,
        data,
        {
          withCredentials: true,
        },
      );
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

const rnfizReducer = (statePart = initialState, action) => {
  switch (action.type) {
    case LOAD_RNFIZ_1:
      return [...action.payload];
    case ADD_RNFIZ_1:
      return [...statePart, action.payload];
    case EDIT_RNFIZ_1:
      return statePart.map((item) =>
        item.id === action.payload.id ? action.payload : item,
      );
    case DELETE_RNFIZ_1:
      return statePart.filter((item) => item.id !== action.payload.id);
    default:
      return statePart;
  }
};

export default rnfizReducer;
